import Vue from 'vue';
import store from 'store';
import {isCurrentAppSeller} from 'utils/appTypeState';
import BodyScroll from 'utils/BodyScroll';
import {SET_ONBOARDING_SEEN} from 'store/modules/user/user';
import MTour from 'onboarding/components/MTour/MTour';
import tracker from 'tracking';
import _ from 'lodash';
_.noConflict();


class BaseOnboarding {
  static get name () {
    throw new Error('Onboarding name is not set');
  }

  static get trackingName () {
    return false;
  }

  static get canRunAgain () {
    return true;
  }

  static async checkCondition () {
    return true;
  }

  constructor (trackingParams) {
    this.trackingParams = trackingParams;
  }

  get params () {
    return {
      showOnce: true,
      disableWindowClicks: false,
      preventBodyScroll: false
    };
  }

  loadAppState () {

    /*
     * load static DOM-components (document.querySelector) here
     * then use them in step events (do not repeat yourself :D)
     */
  }

  steps () {
    return [];
  }

  onStart () {
    if (this.params.disableWindowClicks) {
      this.doDisableWindowClicks();
    }
    if (this.params.preventBodyScroll) {
      BodyScroll.disable();
    }
    this._track({start: true});
  }

  _track ({stepNumber, start, complete, close, back}) {
    const onboardingName = this.constructor.trackingName;

    if (!onboardingName) {
      console.warn('Not tracking onboarding, trackingName is not set');
      return;
    }

    let trackEventName = onboardingName;
    if (!_.isNil(stepNumber)) {
      trackEventName = `${trackEventName}_step_${stepNumber + 1}`;
    } else if (start) {
      trackEventName = `${trackEventName}_start`;
    } else if (complete) {
      trackEventName = `${trackEventName}_complete`;
    } else if (close) {
      return tracker.track('onboarding_close', {type: onboardingName, ...this.trackingParams});
    } else if (back) {
      return tracker.track('onboarding_back', {type: onboardingName, ...this.trackingParams});
    } else {
      throw new Error('Tracking step us not set');
    }
    tracker.track(trackEventName, this.trackingParams);
  }

  onStepBack () {
    const onboardingName = this.constructor.trackingName;
    if (!onboardingName) {
      console.warn('Not tracking onboarding, trackingName is not set');
      return;
    }

    this._track({back: true});
  }

  onStepEnter (stepNumber) {
    if (stepNumber === 0) {

      // do not track first step, it is tracked with %onboarding_name%_start
      return;
    }
    this._track({stepNumber});
  }

  onFinish (meta = {lastPage: 0, skipByCondition: false}) {
    if (this.params.disableWindowClicks) {
      this.doEnableWindowClicks();
    }
    if (this.params.preventBodyScroll) {
      BodyScroll.enable();
    }
    if (meta.success) {
      if (meta.finished) {
        this._track({complete: true});
      } else {
        this._track({close: true});
      }
      if (this.params.showOnce && !isCurrentAppSeller()) {
        store.dispatch(`user/${SET_ONBOARDING_SEEN}`, [
          this.constructor.name,
          {
            last_step: meta.lastStep,
            restarted_count: meta.restartedCount,
            finished: meta.finished,
            seen: meta.finished,
            skip_by_condition: meta.skipByCondition
          }
        ]);
      }
      if (!meta.restart) {
        this.remove();
      }
    }
    this.promiseResolve ? this.promiseResolve() : null;
  }

  skipByCondition () {
    this.onFinish({success: true, skipByCondition: true});
  }

  doDisableWindowClicks () {
    this.clickPreventer = document.createElement('div');
    const container = document.querySelector('#page-layout');
    Object.assign(this.clickPreventer.style, {
      position: 'fixed',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      background: 'rgba(0,0,0, 0)',
      'z-index': 11
    });
    container.appendChild(this.clickPreventer);
  }

  doEnableWindowClicks () {
    this.clickPreventer.remove();
  }

  remove () {
    if (this.app) {
      this.app.$destroy();
      this.app.$el.remove();
      this.app = null;
    }
  }

  run (payload = {}) {
    const promise = new Promise(resolve => {
      this.promiseResolve = resolve;
    });
    const $el = document.querySelector('#onboarding-app');
    this.app = new Vue({
      render: h => h(MTour, {
        props: {
          name: this.constructor.name,
          steps: this.steps(payload),
          globalEvents: {
            on: this.onStart.bind(this),
            off: this.onFinish.bind(this),
            stepEnter: this.onStepEnter.bind(this),
            stepBack: this.onStepBack.bind(this)
          }
        }
      })
    }).$mount();
    $el.appendChild(this.app.$el);
    return promise;
  }
}

export default BaseOnboarding;
